module.exports = __webpack_public_path__ + "img/core-feature-3.144d6dea.png";